<template>
  <div
    class="tw:mt-5 tw:flex tw:flex-col tw:md:flex-row tw:gap-2 tw:p-3 tw:bg-blue-100 tw:border tw:border-blue-300 tw:rounded-xl tw:border-dashed">
    <div class="tw:grow tw:flex tw:flex-col tw:gap-1">
      <h2 class="tw:text-xl tw:font-bold">{{ $t('description_language_tip_header') }}</h2>
      <p>{{ $t('description_language_tip_subtext') }}</p>
      <p class="tw:text-sm">
        <strong>{{ $t('description_plus_tip_header') + ' ' }}</strong>
        <i18n-t keypath="description_plus_tip" tag="span" scope="global">
          <template #VisitorsProfile>
            <router-link
              :to="{ name: 'visitors-profile' }"
              class="tw:text-blue-700 tw:font-bold tw:hover:underline">
              {{ $t('app.visitorsProfile.name') }}
            </router-link>
          </template>
        </i18n-t>
      </p>
    </div>
    <PropertyDescriptionSelectLanguage ctaLabelKey="description_language_new_cta" @languageSelected="addDescription" />
  </div>
</template>

<script setup>
import PropertyDescriptionSelectLanguage from '@/components/propertyDetails/propertyDescriptions/PropertyDescriptionSelectLanguage.vue'

const emit = defineEmits(['languageSelected'])

const addDescription = language => {
  emit('languageSelected', language)
}
</script>
